// config.js
const config = {
  development: {
    apiUrl: "http://localhost:5000",
    cdnUrl: "https://cdn.prexens.com",
    itemsLimit: 50,
  },
  production: {
    // Overridden at build time for the beta (VUE_APP_API_URL build arg)
    apiUrl: process.env.VUE_APP_API_URL || "https://api.prexens.com",
    // Photos: the CDN in prod; the beta API serves its own (VUE_APP_CDN_URL)
    cdnUrl: process.env.VUE_APP_CDN_URL || "https://cdn.prexens.com",
    itemsLimit: 50,
  },
};

// Déterminer l'environnement
const currentEnv = process.env.NODE_ENV || "development";

// Exporter la configuration correspondante
export default config[currentEnv];
